import Header from '@/pages/home/components/Header';
import Hero from '@/pages/home/components/Hero';
import QuickFeed from '@/pages/home/components/QuickFeed';
import DeepRead from '@/pages/home/components/DeepRead';
import DiagramGallery from '@/pages/home/components/DiagramGallery';
import LongReadSeries from '@/pages/home/components/LongReadSeries';
import Collections from '@/pages/home/components/Collections';
import Discussion from '@/pages/home/components/Discussion';
import Footer from '@/pages/home/components/Footer';

export default function Home() {
  return (
    <div className="min-h-screen bg-paper text-ink">
      <Header />
      <main>
        <Hero />
        <QuickFeed />
        <DeepRead />
        <DiagramGallery />
        <LongReadSeries />
        <Collections />
        <Discussion />
      </main>
      <Footer />
    </div>
  );
}